import React from 'react'
import './Features.css'
import pokeballImg from '../assets/img/emojis/pokeball.png'
import superballImg from '../assets/img/emojis/superball.png'
import hyperballImg from '../assets/img/emojis/hyperball.png'
import masterballImg from '../assets/img/emojis/masterball.png'

function Features() {
  const features = [
    {
      iconImg: pokeballImg,
      title: 'Pokéballs',
      description: 'Gérez vos Pokéballs pour capturer les Pokémon. De la pokeball classique à la masterball.',
      commands: ['/ball', '/boutique']
    },
    {
      iconImg: superballImg,
      title: 'Argent',
      description: 'Gagnez de l\'argent en capturant des Pokémon et utilisez-le pour acheter Pokéballs et objets.',
      commands: ['/vendre', '/vendre-shiny', '/argent']
    },
    {
      iconImg: hyperballImg,
      title: 'Pokédex',
      description: 'Consultez votre Pokédex pour suivre votre progression et voir les Pokémon à découvrir.',
      commands: ['/pokedex', '/shinydex', '/pokedex-liste', '/shinydex-liste', '/pokedex-inverse', '/shinydex-inverse']
    },
    {
      iconImg: masterballImg,
      title: 'Shiny Hunting',
      description: 'Recherchez les versions Shiny ultra-rares de vos Pokémon préférés.',
      commands: ['/chance-shiny']
    }
  ]

  return (
    <section id="features" className="features" aria-labelledby="features-title">
      <header>
        <h2 id="features-title" className="section-title">Fonctionnalités</h2>
        <p className="section-subtitle">
          Les outils et mécaniques dont tu disposes
        </p>
      </header>

      <div className="features-grid" role="list">
        {features.map((item, index) => (
          <article key={index} className="feature-card" role="listitem">
            <div className="feature-icon" aria-hidden="true">
              {item.iconImg ? (
                <img src={item.iconImg} alt="" className="feature-icon-img" />
              ) : (
                item.icon
              )}
            </div>
            <h4 className="feature-title">{item.title}</h4>
            <p className="feature-description">{item.description}</p>
            <div className="feature-commands">
              <span className="feature-commands-label">Commande(s)</span>
              <ul className="feature-commands-list" aria-label="Commandes associées">
                {item.commands.map((cmd, i) => (
                  <li key={i}><code>{cmd}</code></li>
                ))}
              </ul>
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}

export default Features
